import functions from "./functions.js";

$(function () {

    const $form = $('.form-contact');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if (!form) {
        return;
    }

    $form.on('submit', e => {
        e.preventDefault();

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        $form.find('.btn').prop('disabled', true).find('i').addClass('la-spinner la-spin');
        grecaptcha.ready(function () {
            grecaptcha.execute('6LdwteAUAAAAAH060o25vAvUMWfTi36uGdDQfhM9', { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;

                $.post('/services/contact.php', params).then(response => {

                    $form.find('.btn').prop('disabled', false).find('i').removeClass('la-spinner la-spin');

                    if (response.status == true) {
                        form.reset();
                        output = lang == 'hr' 
                            ? 'Vaša poruka je poslana. Naš tim će Vam se javiti u najkraćem mogućem roku.' 
                        : (lang == 'de' ? 
                            'Ihre Nachricht wurde gesendet. Unser Team wird sich so schnell wie möglich bei Ihnen melden.'
                                : 'Your message has been sent. Our team will get back to you as soon as possible.');
                        $('.response-output').text(output).removeClass('d-none');
                    } else {
                        output = lang == 'hr'
                            ? 'Došlo je do pogreške. Molimo pokušajte ponovo kasnije ili nas nazovite na dolje navedeni telefon.'
                            : (lang == 'de' ?
                                'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später noch einmal oder rufen Sie uns an.'
                                : 'An error has occurred. Please try again later or call us on the phone below.');
                        $('.response-output').text(output).removeClass('d-none');
                    }

                    setTimeout(() => {
                        $('.response-output').addClass('d-none');
                    }, 5000);
                });
            });
        });

    });

});